// extracted by mini-css-extract-plugin
export var standaloneTable = "_hj-0";
export var standaloneTableWithBodyFill = "_hj-1";
export var withExtraHeader = "_hj-2";